function mobileMenu() { 

  const navigationMenu = document.getElementById('navigation-menu');
  if (!navigationMenu) return;
  
  const navigationMenuToggle = document.getElementById('navigation-menu-toggle');
  const navigationMenuList = navigationMenu.querySelectorAll('.menu-item');

  navigationMenuToggle.addEventListener('click', function (e) {
    if (document.body.dataset.navigation === 'open') {
      document.body.dataset.navigation = 'close';
    } else {
      document.body.dataset.navigation = 'open';
    }
  });

  navigationMenuList.forEach(function (el) { 
    el.querySelector('a').addEventListener('click', function (e) {
      document.body.dataset.navigation = 'close';
    });
  });

}

function add_campaign_parts() { 

  if ('content' in document.createElement('template')) {

    const common_campaign_section = document.querySelectorAll('aside.common-campaign-section');
    const template = document.querySelector('#common-campaign-contents');
    var clone;

    common_campaign_section.forEach(function (el) {
      clone = template.content.cloneNode(true);
      el.appendChild(clone);
    });
  }
}


function init() {
  mobileMenu();
  add_campaign_parts();
}

document.addEventListener('DOMContentLoaded', init);

var startPos = 0, winScrollTop = window.scrollY;
window.addEventListener('scroll', function (e) { 

    winScrollTop = window.pageYOffset;
    winHeight = window.innerHeight;

    if (winScrollTop > 1) {
      document.body.dataset.scroll = "scrolled";
    } else { 
      document.body.dataset.scroll = "unscroll";
    }

    if ( startPos < winHeight * 1.5 || winScrollTop <= 0) {

      document.body.dataset.view = "first";

    } else { 

      document.body.dataset.view = "second";

    }
    startPos = winScrollTop;
  return false;
});
